import withOptions from 'utils/functions/withOptions.util';

import { SET_SELECTED_STAFF } from './feSetSelectedStaff.types';

const feSetSelectedStaff = withOptions(({ group, ids, name }) => ({
  type: SET_SELECTED_STAFF,
  staff: name,
  group,
  name,
  selectedStylistIds: ids,
}));

export default feSetSelectedStaff;
